<template>
  <div v-if="user">
    <div>Name: {{user.first_name}} {{user.last_name}}</div>
    <div>Email: {{user.email}}</div>
    <div v-if="user.job_role">Role: {{user.job_role}}</div>
    <div v-for="{label, value} in personalVars" :key="label">{{label}}: {{value}}</div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  computed: mapGetters(['user', 'personalVars'])
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewProfile.vue